import { AfterViewInit, ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { PeriodCalendarComponent } from '@hglobal/common';

@Component({
  selector: 'pp-period-calendar',
  templateUrl: './period-calendar.component.html',
  styles: [
    `
      :host {
        ::ng-deep.pu-control__input:read-only {
          color: var(--pu-input-txt-filled);
          opacity: 1;
        }
      }
    `,
  ],
  imports: [PeriodCalendarComponent, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarComponent implements AfterViewInit {
  readonly control = input<FormControl>();
  readonly leftMonthToShowByDefault = input<Date>();
  readonly maxDate = input<Date>();
  readonly minDate = input<Date>();
  readonly label = input<string>();
  readonly placeholder = input<string>();

  readonly periodCalendarComponent = viewChild(PeriodCalendarComponent);

  ngAfterViewInit(): void {
    this.periodCalendarComponent().control.disable();
  }
}
